import { render, staticRenderFns } from "./coreWords.vue?vue&type=template&id=1b761517&scoped=true&"
import script from "./coreWords.vue?vue&type=script&lang=js&"
export * from "./coreWords.vue?vue&type=script&lang=js&"
import style0 from "./coreWords.vue?vue&type=style&index=0&id=1b761517&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b761517",
  null
  
)

export default component.exports